export const heroSlides = [
  {
    videoId: "v013",
    label: "本周焦点",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20coastal%20city%20at%20blue%20hour%20viewed%20from%20a%20rooftop%2C%20harbor%20lights%20and%20warm%20amber%20windows%2C%20deep%20navy%20sky%2C%20atmospheric%20haze%2C%20film%20still%2C%20no%20text&width=1600&height=900&seq=tangdou-hero-01&orientation=landscape",
  },
  {
    videoId: "v014",
    label: "热播剧集",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20an%20ancient%20Chinese%20mountain%20fortress%20under%20dramatic%20storm%20clouds%2C%20banners%20in%20the%20wind%2C%20deep%20navy%20sky%20with%20a%20warm%20amber%20break%20of%20light%2C%20cinematic%20historical%20drama%2C%20no%20text&width=1600&height=900&seq=tangdou-hero-02&orientation=landscape",
  },
  {
    videoId: "v023",
    label: "热门综艺",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20sunrise%20shot%20of%20travelers%20on%20a%20high%20mountain%20road%20above%20a%20sea%20of%20clouds%2C%20warm%20amber%20light%2C%20deep%20navy%20valleys%2C%20cinematic%20reality%20show%20key%20art%2C%20no%20text&width=1600&height=900&seq=tangdou-hero-03&orientation=landscape",
  },
  {
    videoId: "v001",
    label: "高分电影",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20city%20street%20in%20rain%2C%20reflections%20of%20warm%20amber%20lamps%20on%20wet%20asphalt%2C%20deep%20navy%20shadows%2C%20moody%20thriller%20atmosphere%2C%20no%20text&width=1600&height=900&seq=tangdou-hero-04&orientation=landscape",
  },
];

export const categoryCovers = {
  movie:
    "https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20film%20reels%20and%20theater%20seats%20in%20deep%20navy%20darkness%20with%20a%20warm%20amber%20projector%20beam%2C%20elegant%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=tangdou-cat-movie&orientation=landscape",
  tv: "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20television%20setup%20glowing%20warm%20amber%20at%20night%2C%20deep%20navy%20shadows%2C%20modern%20minimal%20interior%2C%20soft%20reflections%2C%20no%20text&width=800&height=500&seq=tangdou-cat-tv&orientation=landscape",
  variety:
    "https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20warm%20amber%20spotlights%20and%20audience%20silhouettes%2C%20deep%20navy%20background%2C%20energetic%20entertainment%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=800&height=500&seq=tangdou-cat-variety&orientation=landscape",
};